import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Form, Card, Modal, Col, Row, ProgressBar, Alert, Accordion } from 'react-bootstrap';
import { Table, Segment, Header } from "semantic-ui-react";
import Amplify, { Auth, Storage, API } from 'aws-amplify';
import cookie from 'react-cookies';
import fastaParser from './FastaJS';
import { message, Typography } from 'antd';
import { store } from 'xijs';

function Blast_Submission() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	const [user, setUser] = useState(null);
	const [email, setEmail] = useState(null);
	const [warning, setWarning] = useState(null);
	const [path, setPath] = useState(null);
	const [database, setDatabase] = useState("-");
	const [target, setTarget] = useState(10);
	const [show_e1, setShow_e1] = useState(false);
	const [disable, setDisable] = useState(true);

	// const [add, setAdd] = useState("No");
	const [fastaCount, setFastaCount] = useState();
	const [fileBlast, setFileBlast] = useState();
	const [UID, setUID] = useState();
	const [timeStamp, setTimeStamp] = useState();

	const [isLoading, setIsLoading] = useState();

	var Path;

	const Bucket = "s3://ugtdb-tib-prod-s3tibprodugtdb5094d93f-1rmju6fmzr79j/public/";

	function handleUser(e) {
		let currentuser = e.target.value;
		setUser(currentuser);
	}

	function emailCheck(emailAddr) {
		if ((emailAddr == null) || (emailAddr.length < 2)) return false;

		// 需出现'@',且不在首字符.
		var aPos = emailAddr.indexOf("@", 1);

		if (aPos < 0) {
			return false;
		}

		// '@'后出现'.',且不紧跟其后.
		if (emailAddr.indexOf(".", aPos + 2) < 0) {
			return false;
		}

		return true;
	}

	function handleEmail(e) {
		let currentEmail = e.target.value;
		var isEmail = emailCheck(currentEmail);
		console.log(isEmail);
		if (!isEmail) {
			setWarning('Incorrect Email');
			setShow_e1(true);
			console.log('Incorrect Email');

		} else {
			setEmail(currentEmail);
			setShow_e1(false);
		}

	}

	function handleDatabase(e) {
		setDatabase(e.target.value);
	}

	function handleTarget(e) {
		setTarget(e.target.value);
	}

	function handleFile_af() {
		let ts = new Date();
		setTimeStamp(ts);
		let filename = ts.valueOf() + "/" + "Blast-P450-" + ts.valueOf() + ".fasta";
		let currentID = "Blast-P450-" + ts.valueOf();
		setUID(currentID);

		var reader = new FileReader();
		reader.readAsText(fileBlast);
		reader.onload = function () {
			// console.log(this.result);
			let check = checkFastaFile(this.result);
			if (check) {
				Storage.put(filename, fileBlast, {
					progressCallback(progress) {
						var percentage = (progress.loaded / progress.total * 100).toFixed(1);
						console.log(percentage);
					}
				})
					.then(result => {
						console.log(result);
						Path = Bucket + filename;
						setPath(Path);
						console.log(Path);
						setTimeout(() => {
							message.success({ content: 'Protein sequence file upload completed', style: { marginTop: '40vh' } });
							// setDisable_submit(false);
						}, 500);
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				alert("Not FASTA format.");
			}
		}


	}

	function checkFile(params) {
		setFileBlast(params.target.files[0]);
		const reader = new FileReader();
		reader.readAsText(params.target.files[0]);
		reader.onload = function (e) {
			// console.log(e.target.result);
			const current = e.target.result;
			let arr_1 = current.replaceAll("\n", "&@%$\n").split("\n");
			var count_sequence = 0;
			if (current.startsWith(">")) {
				for (let i = 0; i < arr_1.length; i++) {
					if (arr_1[i].startsWith(">") && arr_1[i].endsWith("&@%$")) {
						count_sequence++;
					}
				}
				setFastaCount(count_sequence);

			} else {
				setFastaCount(0);
			}
		};
	}

	function checkFastaFile(params) {

		if (params.startsWith(">")) {
			let props = params.replaceAll("\r", "");
			var options = {
				'definition': 'gi|accession|description',
				'delimiter': '|'
			};

			var fasta = new fastaParser(options);

			let currentArr = fasta.parse(props);
			// console.log(currentArr);
			for (let i = 0; i < currentArr.length; i++) {
				if (currentArr[i].sequence.replaceAll("\n", "").endsWith("*")) {
					if (currentArr[i].sequence.replaceAll("\n", "").slice(0, -1).match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				} else {
					if (currentArr[i].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				}

			}

			return true

		} else {
			console.log("Not FASTA FORMAT");
			return false;
		}
	}

	useEffect(() => {
		if (fastaCount !== undefined) {
			if (fastaCount === 0) {
				alert("File Error.");
			} else if (fastaCount > 10) {
				alert("Too many sequences.");
			} else {
				handleFile_af();
			}
		}
	}, [fastaCount])


	function saveParams(param1, param2) {
		let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000 * 30);   //  30 days
		// let Name = param1;
		// let Value = param2;
		// cookie.save(Name, Value, { expires: inFifteenMinutes });

		store.set(param1, param1, inFifteenMinutes);
	}



	function handleSubmit() {
		if (database === "-") {
			alert("Please choose a Query Database.");
		} else {
			setIsLoading(true);
			let current = {
				"Timestamp": timeStamp.valueOf(),
				"ID": UID,
				"Sequence_s3_path": path,
				"Database": database,
				"Target": target,
				"Number": fastaCount

			};
			console.log(current);

			async function postRequest() {
				// Amplify.Logger.LOG_LEVEL = "DEBUG";

				const session = await Auth.currentCredentials();
				console.log(session)
				const apiRequest = {
					body: {
						// "Username": user,
						// "Email": email,
						"Timestamp": timeStamp.valueOf(),
						"ID": UID,
						"Sequence_s3_path": path,
						"Database": database,
						"Target": target,
						"Number": fastaCount

					},
					headers: {
						"Content-Type": "application/json",

					},
				};

				return await API
					.post("UGT", "/blastp", apiRequest)
					.then(
						(data) => {
							console.log(data);
							saveParams(UID, current);
							setIsLoading(false);
							setTimeout(
								() => {
									window.location.href = "/blast_results";
								},
								3000
							);
						},
						(error) => {
							console.log(error);
							alert("Network Error!");
							window.location.href = "/blast_submit";
						}
					);
			};
			postRequest();
		}
	}

	// useEffect(() => {
	// 	if (path !== undefined && user !== null && email !== null) {
	// 		setDisable(false);
	// 	} else {
	// 		setDisable(true);
	// 	}
	// }, [path, user, email]);

	return (
		<div style={{
			background: "#FFFFFF"

		}}>

			<Row>
				<Col>
				</Col>
				<Col md={10}>

					<div style={{

						height: "50px"
					}}>
					</div>
					<div>


						<Card>
							<Card.Header>
								<Accordion.Toggle as={Header} eventKey="1" textAlign='center'>
									<span style={{ color: "#6495ED" }} >P450 Blast</span>
								</Accordion.Toggle>
							</Card.Header>
							<Card.Body>
								<Alert show={show_e1} variant="warning" onClose={() => setShow_e1(false)} dismissible>
									<Alert.Heading>Warning</Alert.Heading>
									<p>{warning}</p>
								</Alert>

								<div style={{ margin: "25px 75px 25px 75px" }}>
									<Typography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Search the user-submitted P450 sequence against P450-100 and FunP450. P450-100 contains one million non-redundant P450 sequences, while FunP450 represents all functionally characterized P450 enzymes.</blockquote></Typography.Paragraph>
								</div>
								<Form>
									{/* <Form.Group as={Row} controlId="formBasicUserName">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											User Name:
										</Form.Label>
										<Col sm="8">
											<Form.Control type="text" placeholder="User Name" onChange={handleUser} />
										</Col>


									</Form.Group>

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Email:
										</Form.Label>

										<Col sm="8">
											<Form.Control type="email" placeholder="Email" onChange={handleEmail} />
										</Col>

									</Form.Group> */}

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Protein sequences:
										</Form.Label>

										<Col sm="8">
											<Form.File id="exampleFormControlFile1" onChange={checkFile} accept=".fasta" />
											<Form.Text className="text-muted">Max Length: 10 sequences</Form.Text>
										</Col>

									</Form.Group>

									{/* P450-100、P450-90、P450-60 */}
									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Query database:
										</Form.Label>

										<Col sm="8">
											<Form.Control as="select" onChange={handleDatabase}>
												<option value="-">Please Select Database</option>
												<option value="P450_Known">Known P450</option>
												<option value="P450_All_v2_60">P450-60</option>
												<option value="P450_All_v2_90">P450-90</option>
												<option value="P450_All_v2_100">P450-100</option>
											</Form.Control>
										</Col>
									</Form.Group>

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Max target sequences:
										</Form.Label>

										<Col sm="8">
											<Form.Control as="select" defaultValue="10" onChange={handleTarget} >
												<option>10</option>
												<option>50</option>
												<option>100</option>
												<option>250</option>
												<option>500</option>
												<option>1000</option>
											</Form.Control>
											<Form.Text className="text-muted">Select the maximum number of aligned sequences</Form.Text>
										</Col>

									</Form.Group>

									<div style={{ textAlign: "center" }}>
										<Button
											variant="outline-primary"
											disabled={path === null || isLoading}
											onClick={!isLoading ? handleSubmit : null}

										>
											{isLoading ? 'PROCESSING' : 'SUBMIT'}
										</Button>
									</div>

								</Form>
							</Card.Body>
						</Card>

					</div>


					<div style={{

						height: "50px"
					}}>
					</div>
				</Col>
				<Col>
				</Col>
			</Row>
		</div>

	);
}

export default Blast_Submission;